module.exports = __webpack_public_path__ + "static/media/placeholder.8c6344e1.svg";